// import React, { useState, useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import api from "../../utils/api";

// const ImageDatabase = () => {
//   const { business_id } = useParams();
//   const [formData, setFormData] = useState({
//     employee_name: "",
//     service: "",
//     notes: "",
//   });
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [coordinates, setCoordinates] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [locationError, setLocationError] = useState("");

//   useEffect(() => {
//     requestLocation();
//   }, []);

//   const requestLocation = () => {
//     // Verificar si el sitio está en HTTPS (requerido para iOS)
//     if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
//       setLocationError("Location requires HTTPS connection. Please access via secure connection.");
//       return;
//     }

//     // Verificar si el navegador soporta geolocalización
//     if (!navigator.geolocation) {
//       setLocationError("Your device does not support geolocation.");
//       return;
//     }

//     // Opciones para iOS
//     const options = {
//       enableHighAccuracy: true,
//       timeout: 15000,
//       maximumAge: 0
//     };

//     console.log("Requesting location permission...");

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         setCoordinates({
//           latitude: position.coords.latitude,
//           longitude: position.coords.longitude,
//         });
//         setLocationError("");
//         console.log("Location obtained:", position.coords);
//       },
//       (error) => {
//         let errorMessage = "Could not get location. ";

//         switch(error.code) {
//           case error.PERMISSION_DENIED:
//             errorMessage += "Please enable location permissions in your browser settings.";
//             break;
//           case error.POSITION_UNAVAILABLE:
//             errorMessage += "Location information is unavailable. Make sure GPS/Location Services are enabled.";
//             break;
//           case error.TIMEOUT:
//             errorMessage += "Location request timed out. Please try again.";
//             break;
//           default:
//             errorMessage += "An unknown error occurred.";
//         }

//         setLocationError(errorMessage);
//         console.error("Geolocation error:", error.code, error.message);
//       },
//       options
//     );
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setSelectedImage(file);

//       // Crear preview
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedImage) {
//       setMessage("Please select an image");
//       return;
//     }

//     setLoading(true);
//     setMessage("");

//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append("image", selectedImage);
//       formDataToSend.append("business_id", business_id);

//       // Agregar coordenadas solo si están disponibles
//       if (coordinates) {
//         formDataToSend.append("latitude", coordinates.latitude);
//         formDataToSend.append("longitude", coordinates.longitude);
//       }

//       if (formData.employee_name) {
//         formDataToSend.append("employee_name", formData.employee_name);
//       }
//       if (formData.service) {
//         formDataToSend.append("service", formData.service);
//       }
//       if (formData.notes) {
//         formDataToSend.append("notes", formData.notes);
//       }

//       const response = await api.post("/field_post/create", formDataToSend, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (response.data.success) {
//         setMessage("✅ Image uploaded successfully!");
//         // Clear form
//         setSelectedImage(null);
//         setImagePreview(null);
//         setFormData({
//           employee_name: "",
//           service: "",
//           notes: "",
//         });
//         // Reset file input
//         document.getElementById("imageInput").value = "";
//       }
//     } catch (error) {
//       console.error("Error uploading image:", error);
//       setMessage("❌ Error uploading image. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
//       <div className="max-w-md mx-auto">
//         <div className="bg-white rounded-2xl shadow-xl p-6">
//           <div className="flex justify-between items-start mb-4">
//             <div className="flex-1">
//               <h1 className="text-3xl font-bold text-gray-800 mb-2">
//                 📸 Image Database
//               </h1>
//               <p className="text-gray-600 mb-2">
//                 Upload photos from the field
//               </p>
//             </div>
//             <Link
//               to={`/image_data_base/${business_id}/view`}
//               className="text-indigo-600 hover:text-indigo-800 font-medium text-sm whitespace-nowrap ml-4"
//             >
//               View Gallery →
//             </Link>
//           </div>

//           {/* GPS Status */}
//           <div className="mt-6 mb-6 p-4 rounded-lg bg-gray-50">
//             {coordinates ? (
//               <div className="flex items-center text-green-600">
//                 <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                   <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//                 </svg>
//                 <span className="font-medium">GPS Enabled</span>
//               </div>
//             ) : (
//               <div>
//                 <div className="flex items-center text-yellow-600">
//                   <svg className="animate-spin w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   <span className="font-medium">Getting location...</span>
//                 </div>
//                 {locationError && (
//                   <div className="mt-3">
//                     <p className="text-red-500 text-sm mb-2">{locationError}</p>
//                     <button
//                       onClick={requestLocation}
//                       className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
//                     >
//                       🔄 Retry Location
//                     </button>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           <form onSubmit={handleSubmit} className="space-y-4">
//             {/* Image Selector */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Photo *
//               </label>
//               <input
//                 id="imageInput"
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 className="w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer"
//                 required
//               />
//             </div>

//             {/* Image Preview */}
//             {imagePreview && (
//               <div className="mt-4">
//                 <img
//                   src={imagePreview}
//                   alt="Preview"
//                   className="w-full h-64 object-cover rounded-lg shadow-md"
//                 />
//               </div>
//             )}

//             {/* Employee Name */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Employee Name
//               </label>
//               <input
//                 type="text"
//                 name="employee_name"
//                 value={formData.employee_name}
//                 onChange={handleInputChange}
//                 placeholder="John Doe"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
//               />
//             </div>

//             {/* Service */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Service
//               </label>
//               <input
//                 type="text"
//                 name="service"
//                 value={formData.service}
//                 onChange={handleInputChange}
//                 placeholder="Installation, Maintenance, Repair..."
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
//               />
//             </div>

//             {/* Notes */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Notes
//               </label>
//               <textarea
//                 name="notes"
//                 value={formData.notes}
//                 onChange={handleInputChange}
//                 placeholder="Customer was very happy with the service..."
//                 rows="3"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition resize-none"
//               />
//             </div>

//             {/* Status Message */}
//             {message && (
//               <div className={`p-4 rounded-lg ${
//                 message.includes("✅") ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"
//               }`}>
//                 {message}
//               </div>
//             )}

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               className={`w-full py-4 rounded-lg font-semibold text-white transition-all transform ${
//                 loading
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : "bg-indigo-600 hover:bg-indigo-700 hover:scale-105 shadow-lg hover:shadow-xl"
//               }`}
//             >
//               {loading ? (
//                 <span className="flex items-center justify-center">
//                   <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Uploading...
//                 </span>
//               ) : (
//                 "📤 Upload Image"
//               )}
//             </button>
//           </form>

//           {/* Additional Info */}
//           <div className="mt-6 pt-6 border-t border-gray-200">
//             <p className="text-xs text-gray-500 text-center mb-3">
//               {coordinates 
//                 ? "Images will be saved with your GPS location" 
//                 : "Location is optional. You can upload without GPS."}
//             </p>

//             {/* iOS Instructions */}
//             {locationError && !coordinates && (
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
//                 <p className="text-xs font-semibold text-blue-800 mb-2">
//                   📱 Want to add location? Enable it on your device:
//                 </p>
//                 <ol className="text-xs text-blue-700 space-y-1 list-decimal list-inside">
//                   <li>Go to Settings → Safari → Location</li>
//                   <li>Select "Allow" or "Ask"</li>
//                   <li>Tap "🔄 Retry Location" button above</li>
//                 </ol>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ImageDatabase;


import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../utils/api";

const ImageDatabase = () => {
  const { business_id } = useParams();
  const [formData, setFormData] = useState({
    employee_name: "",
    service: "",
    notes: "",
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [coordinates, setCoordinates] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [locationError, setLocationError] = useState("");

  useEffect(() => {
    requestLocation();
  }, []);

  const requestLocation = () => {
    // Verificar HTTPS
    if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
      setLocationError("Location requires HTTPS connection. Please access via secure connection.");
      return;
    }

    if (!navigator.geolocation) {
      setLocationError("Your device does not support geolocation.");
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0
    };

    console.log("Requesting location permission...");

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoordinates({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setLocationError("");
        console.log("Location obtained:", position.coords);
      },
      (error) => {
        let errorMessage = "Could not get location. ";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage += "Please enable location permissions in your browser settings.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage += "Location information is unavailable. Make sure GPS/Location Services are enabled.";
            break;
          case error.TIMEOUT:
            errorMessage += "Location request timed out. Please try again.";
            break;
          default:
            errorMessage += "An unknown error occurred.";
        }
        setLocationError(errorMessage);
      },
      options
    );
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedImage) {
      setMessage("Please select an image");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("image", selectedImage);
      formDataToSend.append("business_id", business_id);

      if (coordinates) {
        formDataToSend.append("latitude", coordinates.latitude);
        formDataToSend.append("longitude", coordinates.longitude);
      }

      if (formData.employee_name) {
        formDataToSend.append("employee_name", formData.employee_name);
      }
      if (formData.service) {
        formDataToSend.append("service", formData.service);
      }
      if (formData.notes) {
        formDataToSend.append("notes", formData.notes);
      }

      const response = await api.post("/field_post/create", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        setMessage("✅ Image uploaded successfully!");
        setSelectedImage(null);
        setImagePreview(null);
        setFormData({
          employee_name: "",
          service: "",
          notes: "",
        });
        document.getElementById("imageInput").value = "";
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setMessage("❌ Error uploading image. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <div className="flex justify-between items-start mb-4">
            <div className="flex-1">
              <h1 className="text-3xl font-bold text-gray-800 mb-2">
                📸 Image Database
              </h1>
              <p className="text-gray-600 mb-2">
                Upload photos from the field
              </p>
            </div>
            <Link
              to={`/image_data_base/${business_id}/view`}
              className="text-indigo-600 hover:text-indigo-800 font-medium text-sm whitespace-nowrap ml-4"
            >
              View Gallery →
            </Link>
          </div>

          {/* GPS Status */}
          <div className="mt-6 mb-6 p-4 rounded-lg bg-gray-50">
            {coordinates ? (
              <div className="flex items-center text-green-600">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">GPS Enabled</span>
              </div>
            ) : (
              <div>
                <div className="flex items-center text-yellow-600">
                  <svg className="animate-spin w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span className="font-medium">Getting location...</span>
                </div>
                {locationError && (
                  <div className="mt-3">
                    <p className="text-red-500 text-sm mb-2">{locationError}</p>
                    <button
                      onClick={requestLocation}
                      className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
                    >
                      🔄 Retry Location
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Image Selector */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Photo *
              </label>
              <input
                id="imageInput"
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer"
                required
              />
            </div>

            {/* Image Preview */}
            {imagePreview && (
              <div className="mt-4">
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="w-full h-64 object-cover rounded-lg shadow-md"
                />
              </div>
            )}

            {/* Employee Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Employee Name
              </label>
              <input
                type="text"
                name="employee_name"
                inputMode="text" // Optimiza el teclado móvil
                autoComplete="name"
                value={formData.employee_name}
                onChange={handleInputChange}
                placeholder="John Doe"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
              />
            </div>

            {/* Service */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Service
              </label>
              <input
                type="text"
                name="service"
                inputMode="text" // Optimiza el teclado móvil
                value={formData.service}
                onChange={handleInputChange}
                placeholder="Installation, Maintenance, Repair..."
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
              />
            </div>

            {/* Notes */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Notes
              </label>
              <textarea
                name="notes"
                inputMode="text" // Optimiza el teclado móvil
                value={formData.notes}
                onChange={handleInputChange}
                placeholder="Customer was very happy with the service..."
                rows="3"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition resize-none"
              />
            </div>

            {/* Status Message */}
            {message && (
              <div className={`p-4 rounded-lg ${message.includes("✅") ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"
                }`}>
                {message}
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className={`w-full py-4 rounded-lg font-semibold text-white transition-all transform ${loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700 hover:scale-105 shadow-lg hover:shadow-xl"
                }`}
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Uploading...
                </span>
              ) : (
                "📤 Upload Image"
              )}
            </button>
          </form>

          {/* Additional Info */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center mb-3">
              {coordinates
                ? "Images will be saved with your GPS location"
                : "Location is optional. You can upload without GPS."}
            </p>

            {/* iOS Instructions */}
            {locationError && !coordinates && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
                <p className="text-xs font-semibold text-blue-800 mb-2">
                  📱 Want to add location? Enable it on your device:
                </p>
                <ol className="text-xs text-blue-700 space-y-1 list-decimal list-inside">
                  <li>Go to Settings → Safari → Location</li>
                  <li>Select "Allow" or "Ask"</li>
                  <li>Tap "🔄 Retry Location" button above</li>
                </ol>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageDatabase;